// Art
export const REQUEST_ART = 'REQUEST_ART'
export const RECEIVE_ART = 'RECEIVE_ART'
export const PLACE_ART = 'PLACE_ART'
export const SELECT_ART = 'SELECT_ART'
export const QUICK_PREVIEW_ART = 'QUICK_PREVIEW_ART'

// Products (Furniture is the legacy term)
export const REQUEST_FURNITURE_SAGA = 'REQUEST_FURNITURE_SAGA'
export const RECEIVE_FURNITURE = 'RECEIVE_FURNITURE'
export const FAILED_RECEIVE_FURNITURE = 'FAILED_RECEIVE_FURNITURE'
export const REQUEST_FURNITURE_BY_IDS_SAGA = 'REQUEST_FURNITURE_BY_IDS_SAGA'
export const RECEIVE_FURNITURE_BY_IDS = 'RECEIVE_FURNITURE_BY_IDS'
export const FAILED_RECEIVE_FURNITURE_BY_IDS = 'FAILED_RECEIVE_FURNITURE_BY_IDS'
export const REQUEST_FURNITURE_BY_LOCALITEMNOS_SAGA = 'REQUEST_FURNITURE_LOCALITEMNOS_SAGA'
export const RECEIVE_FURNITURE_BY_LOCALITEMNOS = 'RECEIVE_FURNITURE_BY_LOCALITEMNOS'
export const FAILED_RECEIVE_FURNITURE_BY_LOCALITEMNOS = 'FAILED_RECEIVE_FURNITURE_BY_LOCALITEMNOS'
export const REQUEST_FURNITURE_CATEGORIES_SAGA = 'REQUEST_FURNITURE_CATEGORIES_SAGA'
export const RECEIVE_FURNITURE_CATEGORIES = 'RECEIVE_FURNITURE_CATEGORIES'
export const FAILED_RECEIVE_FURNITURE_CATEGORIES = 'FAILED_RECEIVE_FURNITURE_CATEGORIES'
export const REQUEST_FURNITURE_SWAPPABLES_SAGA = 'REQUEST_FURNITURE_SWAPPABLES_SAGA'
export const RECEIVE_FURNITURE_SWAPPABLES = 'RECEIVE_FURNITURE_SWAPPABLES'
export const FAILED_RECEIVE_FURNITURE_SWAPPABLES = 'FAILED_RECEIVE_FURNITURE_SWAPPABLES'
export const SELECT_FURNITURE = 'SELECT_FURNITURE'
export const FURNITURE_FILTER_UPDATE = 'FURNITURE_FILTER_UPDATE'
export const FURNITURE_FILTER_CLEAR = 'FURNITURE_FILTER_CLEAR'
export const SELECT_FURNITURE_SWAP_DETAILS = 'SELECT_FURNITURE_SWAP_DETAILS'
export const REQUEST_FURNITURE_COMBINABLES_SAGA = 'REQUEST_FURNITURE_COMBINABLES_SAGA'
export const RECEIVE_FURNITURE_COMBINABLES = 'RECEIVE_FURNITURE_COMBINABLES'
export const FAILED_RECEIVE_FURNITURE_COMBINABLES = 'FAILED_RECEIVE_FURNITURE_COMBINABLES'
export const FILTER_FEATURED_PRODUCTS = 'FILTER_FEATURED_PRODUCTS'

// Scenes
export const REQUEST_SCENES = 'REQUEST_SCENES'
export const RECEIVE_SCENES = 'RECEIVE_SCENES'
export const FAILED_RECEIVE_SCENES = 'FAILED_RECEIVE_SCENES'
export const SELECT_SCENE = 'SELECT_SCENE'
export const REQUEST_SCENE = 'REQUEST_SCENE'
export const RECEIVE_SCENE = 'RECEIVE_SCENE'
export const FAILED_RECEIVE_SCENE = 'FAILED_RECEIVE_SCENE'
export const UPDATE_SCENE_MANIFEST = 'UPDATE_SCENE_MANIFEST'

// User
export const RECEIVE_USER = 'RECEIVE_USER'
export const REQUEST_USER = 'REQUEST_USER'
export const FAILED_RECEIVE_USER = 'FAILED_RECEIVE_USER'
export const SIGNINGUP_USER = 'SIGNINGUP_USER'
export const RECEIVE_USER_SIGNUP = 'RECEIVE_USER_SIGNUP'
export const LOGGINGIN_USER = 'LOGGINGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const RECEIVE_USER_LOGIN = 'RECEIVE_USER_LOGIN'
export const LOGIN_NEEDED = 'LOGIN_NEEDED'
export const TRIGGER_PASSWORD_RESET = 'TRIGGER_PASSWORD_RESET'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RECEIVE_TRIGGER_PASSWORD_RESET = 'RECEIVE_TRIGGER_PASSWORD_RESET'
export const RECEIVE_RESET_PASSWORD = 'RECEIVE_RESET_PASSWORD'
export const REQUEST_EARLY_ACCESS = 'REQUEST_EARLY_ACCESS'
export const RECEIVE_EARLY_ACCESS = 'RECEIVE_EARLY_ACCESS'
export const REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD'
export const RECEIVE_CHANGE_PASSWORD = 'RECEIVE_CHANGE_PASSWORD'
export const RESET_CHANGE_PASSWORD_STATUS = 'RESET_CHANGE_PASSWORD_STATUS'
export const MAGIC_ERASER_TUTORIAL_SEEN = 'MAGIC_ERASER_TUTORIAL_SEEN'
export const REQUEST_APP_DOWNLOAD_SMS = 'REQUEST_APP_DOWNLOAD_SMS'
export const RECEIVE_APP_DOWNLOAD_SMS = 'RECEIVE_APP_DOWNLOAD_SMS'
export const RESET_APP_DOWNLOAD_SMS_STATUS = 'RESET_APP_DOWNLOAD_SMS_STATUS'
export const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER'
export const REQUEST_LOGIN_PAGE = 'REQUEST_LOGIN_PAGE'

// Preview
export const QUICK_PREVIEW_CLOSE = 'QUICK_PREVIEW_CLOSE'
export const DRAG_VALIDITY_CHANGE = 'DRAG_VALIDITY_CHANGE'
export const UPDATE_PREVIEW_SETTINGS = 'UPDATE_PREVIEW_SETTINGS'
export const SHOW_PLACEABLE_SURFACES = 'SHOW_PLACEABLE_SURFACES'
export const HIDE_PLACEABLE_SURFACES = 'HIDE_PLACEABLE_SURFACES'
export const SET_MAGIC_WINDOW_LOADING = 'SET_MAGIC_WINDOW_LOADING'
export const SET_INITIAL_LOADING = 'SET_INITIAL_LOADING'
export const WALLDATA_READY = 'WALLDATA_READY'

// Compositions
export const SELECT_COMPOSITION = 'SELECT_COMPOSITION'
export const SELECT_COMPOSITION_RENDER_ITEM = 'SELECT_COMPOSITION_RENDER_ITEM'
export const DELETE_COMPOSITION_RENDER_ITEM = 'DELETE_COMPOSITION_RENDER_ITEM'
export const UPDATE_COMPOSITION_RENDER_ITEM = 'UPDATE_COMPOSITION_RENDER_ITEM'
export const CLEAR_SWAP_AFFINITY = 'CLEAR_SWAP_AFFINITY'
export const REQUEST_SAVE_COMPOSITION = 'REQUEST_SAVE_COMPOSITION'
export const RECEIVE_SAVE_COMPOSITION = 'RECEIVE_SAVE_COMPOSITION'
export const FAILED_SAVE_COMPOSITION = 'FAILED_SAVE_COMPOSITION'
export const REQUEST_COMPOSITIONS_SAGA = 'REQUEST_COMPOSITIONS_SAGA'
export const RECEIVE_COMPOSITIONS = 'RECEIVE_COMPOSITIONS'
export const FAILED_RECEIVE_COMPOSITIONS = 'FAILED_RECEIVE_COMPOSITIONS'
export const REQUEST_COMPILED_COMPOSITION_SAGA = 'REQUEST_COMPILED_COMPOSITION_SAGA'
export const RECEIVE_COMPILED_COMPOSITION = 'RECEIVE_COMPILED_COMPOSITION'
export const FAILED_RECEIVE_COMPILED_COMPOSITION = 'FAILED_RECEIVE_COMPILED_COMPOSITION'
export const UPDATE_HIDDEN_SURFACES = 'UPDATE_HIDDEN_SURFACES'
export const SET_COMPOSITION_PRE_FETCH_LOADING = 'SET_COMPOSITION_PRE_FETCH_LOADING'
export const RENAME_COMPOSITION = 'RENAME_COMPOSITION'
export const START_DRAG_RENDER_ITEM = 'START_DRAG_RENDER_ITEM'
export const STOP_DRAG_RENDER_ITEM = 'STOP_DRAG_RENDER_ITEM'
export const PLACE_RENDER_ITEM = 'PLACE_RENDER_ITEM'
export const START_PLACE_STACKABLE_ITEM = 'START_PLACE_STACKABLE_ITEM'
export const CLICK_PLACE_RENDER_ITEM = 'CLICK_PLACE_RENDER_ITEM'
export const CLICK_PLACE_STACKABLE_ITEM = 'CLICK_PLACE_STACKABLE_ITEM'
export const CLICK_PLACE_STACKABLE_ON_FLOOR = 'CLICK_PLACE_STACKABLE_ON_FLOOR'
export const REQUEST_DELETE_COMPOSITION = 'REQUEST_DELETE_COMPOSITION'
export const RECEIVE_DELETE_COMPOSITION = 'RECEIVE_DELETE_COMPOSITION'
export const OPEN_COMPOSITION = 'OPEN_COMPOSITION'
export const SHARE_COMPOSITION = 'SHARE_COMPOSITION'
export const RENDER_ITEM_LOADED = 'RENDER_ITEM_LOADED'
export const WALLART_ITEM_LOADED = 'WALLART_ITEM_LOADED'
export const SWAP_RENDER_ITEM = 'SWAP_RENDER_ITEM'
export const START_SWAP_STACKABLE_SURFACE = 'START_SWAP_STACKABLE_SURFACE'
export const DUPLICATE_RENDER_ITEM = 'DUPLICATE_ITEM'
export const STACKABLE_SURFACE_CLICKED = 'STACKABLE_SURFACE_CLICKED'
export const SWAP_STACKABLE_SURFACE = 'SWAP_STACKABLE_SURFACE'
export const SWAP_STACKABLE_TO_FLOOR = 'SWAP_STACKABLE_TO_FLOOR'
export const UPDATE_COMPOSITION_SAVE_DATA = 'UPDATE_COMPOSITION_SAVE_DATA'
export const REMOVE_RENDER_ITEMS = 'REMOVE_RENDER_ITEMS'
export const UNDO_REMOVE_RENDER_ITEMS = 'UNDO_REMOVE_RENDER_ITEMS'
export const SCHEDULE_DELAYED_SCREENSHOT = 'SCHEDULE_DELAYED_SCREENSHOT'
export const DELAYED_SCREENSHOT_SCHEDULED = 'DELAYED_SCREENSHOT_SCHEDULED'
export const DELAYED_SCREENSHOT_SENT = 'DELAYED_SCREENSHOT_SENT'
export const FIRST_RENDER_ITEM_SCREENSHOT_DONE = 'FIRST_RENDER_ITEM_SCREENSHOT_DONE'
export const SET_WALL_COLOR = 'SET_WALL_COLOR'

// Renderer
export const NEW_RENDERER = 'NEW_RENDERER'
export const DESTROY_RENDERER = 'DESTROY_RENDERER'
export const RENDERER_READY = 'RENDERER_READY'
export const FIRST_RENDER = 'FIRST_RENDER'
export const WEBGL_CONTEXT_LOST = 'WEBGL_CONTEXT_LOST'
export const WEBGL_CONTEXT_NOT_CREATED = 'WEBGL_CONTEXT_NOT_CREATED'
export const WEBGL_CONTEXT_RESTORED = 'WEBGL_CONTEXT_RESTORED'

// Ratings
export const REQUEST_RATINGS = 'REQUEST_RATINGS'
export const RECEIVE_RATING = 'RECEIVE_RATING'
export const RECEIVE_RATINGS = 'RECEIVE_RATINGS'
export const REQUEST_RATING_OPTIONS = 'REQUEST_RATING_OPTIONS'
export const RECEIVE_RATING_OPTIONS = 'RECEIVE_RATING_OPTIONS'
export const SUBMIT_RATING = 'SUBMIT_RATING'
export const INITIALIZATION_FAILURE = 'INITIALIZATION_FAILURE'

// Admin
export const REQUEST_SAVE_ART = 'REQUEST_SAVE_ART'
export const REQUEST_NEW_ART = 'REQUEST_NEW_ART'
export const REQUEST_GT = 'REQUEST_GT'
export const RECEIVE_GT = 'RECEIVE_GT'
export const REQUEST_DOWNLOAD = 'REQUEST_DOWNLOAD'
export const RECEIVE_DOWNLOAD = 'RECEIVE_DOWNLOAD'
export const UPDATE_DEBUG_SETTINGS = 'UPDATE_DEBUG_SETTINGS'
export const SET_ADMIN = 'SET_ADMIN'
export const TRIGGER_COMPOSITION_LOAD = 'TRIGGER_COMPOSITION_LOAD'
export const START_TEST_SWAP_SAGA = 'START_TEST_SWAP_SAGA'
export const TEST_SWAP_SAGA_FINISHED = 'TEST_SWAP_SAGA_FINISHED'
export const START_TEST_LOAD_SAGA = 'START_TEST_LOAD_SAGA'
export const TEST_LOAD_SAGA_FINISHED = 'TEST_LOAD_SAGA_FINISHED'

// UI
export const COMPOSITIONS_TOGGLE = 'COMPOSITIONS_TOGGLE'
export const SCENES_TOGGLE = 'SCENES_TOGGLE'
export const SCENES_OPEN = 'SCENES_OPEN'
export const ART_TOGGLE = 'ART_TOGGLE'
export const OPEN_DESIGN_SIDEPANEL = 'OPEN_DESIGN_SIDEPANEL'
export const CLOSE_DESIGN_SIDEPANEL = 'CLOSE_DESIGN_SIDEPANEL'
export const PRESENT_ITEM_SELECTION = 'PRESENT_ITEM_SELECTION'
export const ART_TRAY_FILTER = 'ART_TRAY_FILTER'
export const ITEM_SELECTION_DISPLAY = 'ITEM_SELECTION_DISPLAY'
export const CLOSE_WELCOME_POPUP = 'CLOSE_WELCOME_POPUP'
export const SET_DESIGN_SIDEPANEL_MODE = 'SET_DESIGN_SIDEPANEL_MODE'
export const SHARE_PANEL_OPEN_TOGGLE = 'SHARE_PANEL_OPEN_TOGGLE'
export const SELECT_SCENE_SELECTION_TAB = 'SELECT_SCENE_SELECTION_TAB'
export const RELOAD_PAGE = 'RELOAD_PAGE'
export const SET_FILTER_MODAL_OPEN = 'SET_FILTER_MODAL_OPEN'
export const SHOW_SWAP_MENU = 'SHOW_SWAP_MENU'
export const SHOW_MISSING_WALLS_MODAL = 'SHOW_MISSING_WALLS_MODAL'
export const OPEN_DESIGN_LAB = 'OPEN_DESIGN_LAB'
export const SET_MOBILE_ORIENTATION = 'SET_MOBILE_ORIENTATION'
export const SHOW_LOGIN_PROMPT_MODAL = 'SHOW_LOGIN_PROMPT_MODAL'
export const SHOW_DESIGN_SUMMARY = 'SHOW_DESIGN_SUMMARY'

// iFrame
export const NEW_IFRAME_MESSAGE = 'NEW_IFRAME_MESSAGE'

// Tracking
export const TRACK_ADD_PRODUCT_TO_BAG = 'TRACK_ADD_PRODUCT_TO_BAG'
export const TRACK_ADD_ROOM_TO_BAG = 'TRACK_ADD_ROOM_TO_BAG'
export const TRACK_SHOW_DETAILS = 'TRACK_SHOW_DETAILS'

// Tokens
export const REQUEST_IKEA_TOKENS = 'REQUEST_IKEA_TOKENS'
export const RECEIVE_IKEA_TOKENS = 'RECEIVE_IKEA_TOKENS'

// Bag (cart)
export const ADD_TO_BAG = 'ADD_TO_BAG'
export const ADD_ROOM_TO_BAG = 'ADD_ROOM_TO_BAG'
export const OPEN_BAG = 'OPEN_BAG'

// Favorites
export const REQUEST_FAVORITES = 'REQUEST_FAVORITES'
export const RECEIVE_FAVORITES = 'RECEIVE_FAVORITES'
export const FAILED_RECEIVE_FAVORITES = 'FAILED_RECEIVE_FAVORITES'
export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE'
export const TOGGLE_FAVORITES = 'TOGGLE_FAVORITES'

// Toast
export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'

// Support
export const REQUEST_STATUS = 'REQUEST_STATUS'
export const RECEIVE_STATUS = 'RECEIVE_STATUS'
export const FAILED_RECEIVE_STATUS = 'FAILED_RECEIVE_STATUS'

// LocalStorage
export const SAVE_SELECTED_COMPOSITION_TO_LOCAL_STORAGE = 'SAVE_SELECTED_COMPOSITION_TO_LOCAL_STORAGE'
export const LOAD_COMPOSITION_FROM_LOCAL_STORAGE = 'LOAD_COMPOSITION_FROM_LOCAL_STORAGE'

// Kiosk
export const SELECT_KIOSK_ROOM_TYPE = 'SELECT_KIOSK_ROOM_TYPE'
export const SET_KIOSK_INTRO_VIEWED = 'SET_KIOSK_INTRO_VIEWED'
